import { put } from 'redux-saga/effects'
import { IPcr } from '../../../pcr/store/pcr.types'
import { setRespiratory } from '../store/respiratory.actions'
import { getSelectedDataFromObject } from '../../../../utilities/data.util'
import { respiratoryStatePrNabc } from '../store/respiratory.reducers'

export function* getRespiratory(pcrDoc: IPcr) {
  if (pcrDoc && pcrDoc.prNabc) {
    const respPrNabcKeys: any = Object.keys(respiratoryStatePrNabc)
    const respPrNabcData = getSelectedDataFromObject(pcrDoc.prNabc, respPrNabcKeys)

    if (respPrNabcData && Object.keys(respPrNabcData).length !== 0) {
      yield put(setRespiratory({ ...respPrNabcData }))
    }
    yield put(setRespiratory({ respExam: pcrDoc.prRespAssess || [] }))
  }
}
